import { BACKEND_URL } from "../url/Url";

const ABSENCE_PERSONNEL_BASE = `${BACKEND_URL}/gestion-personnel/`;


const getAuthHeaders = () => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken}`,
  };
};

const AbsencePersonnelService = {
  all: async () => {
    try {
      const response = await fetch(`${ABSENCE_PERSONNEL_BASE}personnels-absents`, {
        headers: getAuthHeaders(),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des statuts d\'absence du personnel:', error);
      return { success: false, error: error.message };
    }
  },

  add: async (absencePersonnelData) => {
    try {
      const response = await fetch(`${ABSENCE_PERSONNEL_BASE}personnels-absent/ajout/`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(absencePersonnelData)
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de l\'ajout d\'un statut d\'absence du personnel:', error);
      return { success: false, error: error.message };
    }
  },

  update: async (id_absence_personnel, absencePersonnelData) => {
    const userID = parseInt(localStorage.getItem('userId'));
    const payload = {
      data: absencePersonnelData,
      user_id: userID
    };
    console.log("Payload:", payload);

    try {
      const response = await fetch(`${ABSENCE_PERSONNEL_BASE}personnels-absent/modification/${id_absence_personnel}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la mise à jour du statut d\'absence du personnel:', error);
      return { success: false, error: error.message };
    }
  },

  delete: async (id_absence_personnel) => {
    try {
      const response = await fetch(`${ABSENCE_PERSONNEL_BASE}personnels-absent/suppression/${id_absence_personnel}/${localStorage.getItem('accessToken')}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      if (response.ok) {
        return { success: true };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la suppression du statut d\'absence du personnel:', error);
      return { success: false, error: error.message };
    }
  },

  getById: async (id_absence_personnel) => {
    try {
      const response = await fetch(`${ABSENCE_PERSONNEL_BASE}${id_absence_personnel}`, {
        headers: getAuthHeaders()
      });
      if (response.ok) {
        const result = await response.json();
        return { success: true, data: result };
      } else {
        const errorData = await response.json();
        alert(errorData.error);
        return { success: false, error: errorData.error };
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du statut d\'absence du personnel:', error);
      return { success: false, error: error.message };
    }
  }
};

export default AbsencePersonnelService;
